import {Component, OnInit, ViewChild} from '@angular/core';

import { PaginationInstance } from 'ngx-pagination';
import { AdminService } from '../../../services/admin.service';
import { User } from '../../../Models/user';
import { GenericModalService } from '../../../services/generic-modal.service';
import { UserModalComponent } from './user-modal.component';
import { WebClientConfigurationService } from '../../../services/configuration/web-client-configuration.service';
import {WfTableComponent} from '../../../common/table-sort/wf-table.component';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})

export class UserListComponent implements OnInit {

  userList: User[] = null;
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  public config: PaginationInstance;

  filterText: string;
  onlyEnabled: boolean;
  destComponent: any = UserModalComponent;
  errorMessage = '';

  constructor(
    private admin: AdminService,
    private modalService: GenericModalService,
    private webClientConfig: WebClientConfigurationService
  ) {  }

  ngOnInit() {
    this.getPaginationConfig();
    this.admin.loadUserList()
      .subscribe(q => this.userList = q, e => this.errorMessage = e);
  }

  filterData() {
    const emptyFilter = (this.userList && this.userList.length === 0) || this.filterText === undefined || this.filterText.trim() === '';
    if (emptyFilter && !this.onlyEnabled) {
      return this.userList;
    }
    if (emptyFilter && this.onlyEnabled) {
      return this.userList.filter((v) => {
        return v.enabled;
      });
    }

    if (!emptyFilter && this.onlyEnabled) {
      return this.userList.filter((v) => {
        return (
          ( v.logon.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0 ||
            v.firstName && v.firstName.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0 ||
            v.lastName && v.lastName.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0 ||
            v.email && v.email.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0)
          && v.enabled
        );
      });
    }
    if (!emptyFilter && !this.onlyEnabled) {
      return this.userList.filter((v) => {
        return ( v.logon.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0 ||
          v.firstName && v.firstName.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0 ||
          v.lastName && v.lastName.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0 ||
          v.email && v.email.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0);
      });
    }
  }

  onAddNew() {
    const result$ = this.modalService.showModal(this.destComponent, 'Novo Usuário');
    result$.asObservable()
      .pipe()
      .subscribe(
        result => {
          this.ngOnInit();
        }
      );
  }

  onEdit(userId, logon) {
    const result$ = this.modalService.showModal(this.destComponent, 'Editar Usuário', userId, logon);
    result$.asObservable()
      .pipe()
      .subscribe(
        result => {
          this.ngOnInit();
        }
      );
  }

  getPaginationConfig() {
    this.webClientConfig.getPageSizeConfig().subscribe(item => {
      this.config  = {
        id: 'custom',
        itemsPerPage: item,
        currentPage: 1
      };
    });
  }
}
